import React from "react";

export default function TypingIndicator() {
  return (
    <div className="flex gap-1 items-center py-2">
      <span className="w-2 h-2 bg-slate-400 rounded-full animate-bounce" />
      <span className="w-2 h-2 bg-slate-400 rounded-full animate-bounce delay-75" />
      <span className="w-2 h-2 bg-slate-400 rounded-full animate-bounce delay-150" />
    </div>
  );
}
